import { openMockDialog } from './dialog-actions';
/**
 * Not implemented yet.
 * It means to test the workflow in a sandboxed environment.
 */
export function testCurrentWorkflow(app) {
    openMockDialog(app);
}
/**
 * Not implemented yet.
 * It means to publish the workflow to a production environment.
 */
export function publishCurrentWorkflow(app) {
    openMockDialog(app);
}
